import React from 'react'
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div>
        <div className='breadcrumb'>Home : Services</div>
        <div className='ibodywrap'>
            <section>
                <div className='service-panel p0'>
                    <div className='heading'>
                        By Professional Services
                        <div className='sub-heading'>Doctors, gyms, and fitness services at your doorstep</div>
                    </div>
                    <div className='blisting w100'>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='listbox'>
                            <Link to="/" className='list-nav'>
                                <div className='icon-box'><img src='images/agriculture.png' className='fullimg' alt='agriculture' /></div>
                                <div className='title'>General Store</div>
                            </Link>
                        </div>
                        <div className='clr'></div>
                    </div>
                </div>
            </section>
        </div>
    </div>
  )
}

export default Services
